import {action} from "typesafe-actions";



export enum ChatSettingActions{
    APPLICATION_THEME="ChatSetting/GetApplicationTheme",
    APPLICATION_THEME_RESULT="ChatSetting/GetApplicationResult"
};


export const applicationThemeAction =()=>action(ChatSettingActions.APPLICATION_THEME);

export const applicationThemeResult = (payload: any) => action(ChatSettingActions.APPLICATION_THEME_RESULT, payload);
